import { apiDelete, apiGet, apiPost, apiPut } from '@/shared/utils/requestBuilder';
import type {
  CheckAccessResponse,
  CreateProcessoPermissaoDto,
  ProcessoPermissaoDto,
  UpdateProcessoPermissaoDto,
  UsuarioBuscaDto,
} from '@/types/processo/processoPermissaoTypes';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

async function parseResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || `HTTP ${response.status}`);
  }
  const json = (await response.json()) as ApiResponse<T>;
  return json.data;
}

export const processoPermissoesService = {
  async buscarUsuarios(email?: string, nome?: string): Promise<UsuarioBuscaDto[]> {
    const params = new URLSearchParams();
    if (email) params.append('email', email);
    if (nome) params.append('nome', nome);

    const response = await apiGet(`/usuarios/search?${params.toString()}`);
    return parseResponse<UsuarioBuscaDto[]>(response);
  },

  async listar(processoId: string): Promise<ProcessoPermissaoDto[]> {
    const response = await apiGet(`/processos/${processoId}/permissoes`);
    return parseResponse<ProcessoPermissaoDto[]>(response);
  },

  async criar(processoId: string, data: CreateProcessoPermissaoDto): Promise<ProcessoPermissaoDto> {
    const response = await apiPost(`/processos/${processoId}/permissoes`, data);
    return parseResponse<ProcessoPermissaoDto>(response);
  },

  async atualizar(
    processoId: string,
    usuarioId: string,
    data: UpdateProcessoPermissaoDto,
  ): Promise<ProcessoPermissaoDto> {
    const response = await apiPut(`/processos/${processoId}/permissoes/${usuarioId}`, data);
    return parseResponse<ProcessoPermissaoDto>(response);
  },

  async remover(processoId: string, usuarioId: string): Promise<void> {
    const response = await apiDelete(`/processos/${processoId}/permissoes/${usuarioId}`);
    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || `HTTP ${response.status}`);
    }
  },

  async verificarAcesso(processoId: string): Promise<CheckAccessResponse> {
    const response = await apiGet(`/processos/${processoId}/permissoes/check-access`);
    return parseResponse<CheckAccessResponse>(response);
  },
};
